import { t } from '../../utils/i18n';
import { HOW_IT_WORKS_PHOTOS } from './constants';

const STEPS = [
  { step: 1, key: 'step1', photo: HOW_IT_WORKS_PHOTOS.search },
  { step: 2, key: 'step2', photo: HOW_IT_WORKS_PHOTOS.contact },
  { step: 3, key: 'step3', photo: HOW_IT_WORKS_PHOTOS.start },
];

export default function HowItWorks() {
  return (
    <section className="landing-section">
      <div className="landing-container">
        <header className="text-center mb-10 sm:mb-12">
          <h2 className="landing-section-title">
            {t('landing.howItWorks.title')}
          </h2>
          <p className="landing-section-subtitle mx-auto">
            {t('landing.howItWorks.subtitle')}
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {STEPS.map((s) => (
            <article key={s.step} className="landing-step-card group flex flex-col">
              <div className="relative aspect-[4/3] overflow-hidden rounded-t-2xl">
                <img
                  src={s.photo.src}
                  alt={s.photo.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
                <span className="landing-step-badge absolute top-3 left-3" aria-hidden="true">
                  {s.step}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5 rounded-b-2xl">
                <h3 className="text-base font-semibold text-[var(--color-text)] mb-1.5">
                  {t(`landing.howItWorks.${s.key}.title`)}
                </h3>
                <p className="text-[15px] text-[var(--color-text-muted)] leading-relaxed">
                  {t(`landing.howItWorks.${s.key}.desc`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
